import { Board, EMPTY } from '@/types/game';

type Player = 1 | 2;

const directions = [
  [-1, -1], [-1, 0], [-1, 1],
  [0, -1],           [0, 1],
  [1, -1], [1, 0], [1, 1]
];

export const cloneBoard = (board: Board): Board => 
  board.map(row => [...row]);

export const isValidMove = (board: Board, row: number, col: number, player: Player): boolean => {
  if (board[row][col] !== EMPTY) return false;

  for (const [dr, dc] of directions) {
    let r = row + dr;
    let c = col + dc;
    let foundOpponent = false;

    while (r >= 0 && r < 8 && c >= 0 && c < 8 && board[r][c] !== EMPTY && board[r][c] !== player) {
      foundOpponent = true;
      r += dr;
      c += dc;
    }

    if (foundOpponent && r >= 0 && r < 8 && c >= 0 && c < 8 && board[r][c] === player) {
      return true;
    }
  }
  return false;
};

export const getValidMoves = (board: Board, player: Player): [number, number][] => {
  const validMoves: [number, number][] = [];
  for (let r = 0; r < 8; r++) {
    for (let c = 0; c < 8; c++) {
      if (isValidMove(board, r, c, player)) {
        validMoves.push([r, c]);
      }
    }
  }
  return validMoves;
};

export const makeMove = (board: Board, row: number, col: number, player: Player): Board => {
  const newBoard = cloneBoard(board);
  newBoard[row][col] = player;
  const opponent = player === 1 ? 2 : 1;

  for (const [dr, dc] of directions) {
    let r = row + dr;
    let c = col + dc;
    const piecesToFlip: [number, number][] = [];

    while (r >= 0 && r < 8 && c >= 0 && c < 8 && newBoard[r][c] === opponent) {
      piecesToFlip.push([r, c]);
      r += dr;
      c += dc;
    }

    if (r >= 0 && r < 8 && c >= 0 && c < 8 && newBoard[r][c] === player) {
      for (const [fr, fc] of piecesToFlip) {
        newBoard[fr][fc] = player;
      }
    }
  }
  return newBoard;
};

export const calculateScores = (board: Board): { black: number; white: number } => {
  let black = 0;
  let white = 0;
  for (let r = 0; r < 8; r++) {
    for (let c = 0; c < 8; c++) {
      if (board[r][c] === 1) black++;
      else if (board[r][c] === 2) white++;
    }
  }
  return { black, white };
};

export const checkGameOver = (board: Board): boolean => {
  const blackMoves = getValidMoves(board, 1);
  const whiteMoves = getValidMoves(board, 2);
  return blackMoves.length === 0 && whiteMoves.length === 0;
};

export const initialBoard = (): Board => {
  const board: Board = Array(8).fill(0).map(() => Array(8).fill(EMPTY));
  board[3][3] = 2; // 白
  board[3][4] = 1; // 黒
  board[4][3] = 1; // 黒
  board[4][4] = 2; // 白
  return board;
}; 
